import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "required"
}
const _hoisted_2 = { key: 0 }

import { computed, onMounted, onUnmounted, ref, toRefs, watch } from 'vue'
import CheckBoxStandard from '@/design-system/atoms/CheckBoxStandard.vue'
import DropdownRow from '@/design-system/atoms/DropdownRow.vue'
import DropdownHeader from '@/design-system/atoms/DropdownHeader.vue'
import TooltipStandard from '@/design-system/atoms/TooltipStandard.vue'
import DividerHorizontal from '@/design-system/atoms/DividerHorizontal.vue'

import { useI18n } from 'vue-i18n'
export type optionType = {
  disabled: boolean
  id: string
  name: string
  selected: boolean
  subtitle?: string
  value?: Array<any>
}
interface MAP_MENU_PROPS {
  disabled?: boolean
  hasSearch?: boolean
  isAllSelected?: boolean
  label?: string
  multiSelect?: boolean
  options: optionType[]
  required?: boolean
  searchType?: string
  title: string
}
interface EMITS {
  (e: 'select', id: string): void
  (e: 'close'): void
  (e: 'selectAll')
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownStandard',
  props: {
    disabled: { type: Boolean },
    hasSearch: { type: Boolean },
    isAllSelected: { type: Boolean },
    label: {},
    multiSelect: { type: Boolean },
    options: {},
    required: { type: Boolean },
    searchType: {},
    title: {}
  },
  emits: ["select", "close", "selectAll"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const { title, options, searchType } = toRefs(props)
const { t } = useI18n()

const activeIndex = ref(0)
const dropdownRef = ref<HTMLElement | null>(null)
const hoveredTitle = ref<string>('')
const inputText = ref<string>('')
const isOpen = ref(false)
const lastNavigationWay = ref<'hover' | 'key' | ''>('')
const showTooltip = ref(false)
const trackedMouseEvent = ref<Object>()

let lastMousePosition = [0, 0]

onMounted(() => document.addEventListener('click', close))
onUnmounted(() => document.removeEventListener('click', close))

const filteredOptions = computed(() => {
  if (['', t('general__text__all')].includes(inputText.value)) return options.value
  return options.value.filter((option) =>
    option.name.toLowerCase().includes(inputText.value.toLowerCase())
  )
})

function close(event: MouseEvent | TouchEvent) {
  if (!isOpen.value) return
  inputText.value = ''
  const target = event.target as HTMLElement
  if (!dropdownRef.value?.contains(target)) {
    isOpen.value = false
    activeIndex.value = 0
    emits('close')
  }
}
function onNextOption(event: KeyboardEvent) {
  if (!isOpen.value) return
  showTooltip.value = false
  if (event.key === 'ArrowDown' && activeIndex.value < filteredOptions.value.length - 1) {
    activeIndex.value++
    lastNavigationWay.value = 'key'
  } else if (event.key === 'ArrowUp' && activeIndex.value > 0) {
    activeIndex.value--
    lastNavigationWay.value = 'key'
  } else if (event.key === 'Enter') {
    const option = filteredOptions.value[activeIndex.value]
    if (option) onSelect(option.id, option.disabled)
  }
}
function onSelect(id: string, disabled: boolean) {
  if (disabled) return
  options.value.filter((opt) => {
    if (opt.id === id) {
      opt.selected = true
      inputText.value = opt.name
    } else {
      opt.selected = false
      inputText.value = ''
    }
  })
  if (!props.multiSelect) isOpen.value = false
  emits('select', id)
}
function onTextChange(text: string) {
  isOpen.value = true
  inputText.value = text
  activeIndex.value = 0
}
function toggleDropdown() {
  if (props.disabled) return
  isOpen.value = !isOpen.value
  if (!isOpen.value) {
    emits('close')
  }
  inputText.value = ''
  activeIndex.value = 0
}
function trackPointer(event, index: number, tooltipText: string, subtitle: string | undefined) {
  hoveredTitle.value = subtitle ? tooltipText + ' (' + subtitle + ')' : tooltipText
  const rect = event.currentTarget.getBoundingClientRect()
  if (event) {
    if (lastMousePosition[0] === event.clientX && lastMousePosition[1] === event.clientY) return
    lastMousePosition = [event.clientX, event.clientY]
    trackedMouseEvent.value = {
      x: rect.left + rect.width / 2,
      y: rect.bottom + rect.height / 2
    }
    const targetEl = event.target as HTMLElement
    if (targetEl.firstElementChild) {
      showTooltip.value =
        targetEl.firstElementChild.clientWidth < targetEl.firstElementChild.scrollWidth
    }
  }
  activeIndex.value = index
  lastNavigationWay.value = 'hover'
}

function selectAll() {
  emits('selectAll')
}
watch(title, (newTitle) => {
  if (newTitle) inputText.value = ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownRef",
    ref: dropdownRef,
    class: _normalizeClass(["dropdown-container", { 'dropdown-container__disabled': _ctx.disabled }]),
    onKeyup: onNextOption
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["dropdown-container__label", { 'dropdown-container__label__disabled': _ctx.disabled }])
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, " *"))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(DropdownHeader, {
      class: "dropdown-container__header",
      hasSearch: _ctx.hasSearch,
      isOpen: isOpen.value,
      searchType: _unref(searchType),
      title: _unref(title),
      value: inputText.value,
      disabled: _ctx.disabled,
      onToggle: toggleDropdown,
      onChange: onTextChange,
      onFocus: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true)),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (isOpen.value = false), ["tab"])),
      onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (isOpen.value = true), ["tab"]))
    }, null, 8, ["hasSearch", "isOpen", "searchType", "title", "value", "disabled"]),
    _withDirectives(_createElementVNode("div", {
      class: "dropdown-container__window",
      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (showTooltip.value = false))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["options", { options__no_scroll: filteredOptions.value.length < 5 }])
      }, [
        (_ctx.multiSelect)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(CheckBoxStandard, {
                class: "checkbox",
                title: _ctx.$t('general__data__select-all'),
                checked: _ctx.isAllSelected,
                onValueChanged: selectAll
              }, null, 8, ["title", "checked"]),
              _createVNode(DividerHorizontal, { margin: "medium" })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option, index) => {
          return (_openBlock(), _createBlock(DropdownRow, {
            key: option.id,
            activeIndex: activeIndex.value,
            disabled: option.disabled,
            index: index,
            lastNavigationWay: lastNavigationWay.value,
            selected: option.selected,
            subtitle: option.subtitle ? option.subtitle : '',
            title: option.name,
            onOnClicked: ($event: any) => (onSelect(option.id, option.disabled)),
            onOnHover: (e) => trackPointer(e, index, option.name, option.subtitle ?? '')
          }, null, 8, ["activeIndex", "disabled", "index", "lastNavigationWay", "selected", "subtitle", "title", "onOnClicked", "onOnHover"]))
        }), 128))
      ], 2)
    ], 544), [
      [_vShow, isOpen.value]
    ]),
    _withDirectives(_createVNode(TooltipStandard, {
      arrowPosition: "top-center",
      class: "tooltip",
      pointerEvent: trackedMouseEvent.value,
      text: hoveredTitle.value
    }, null, 8, ["pointerEvent", "text"]), [
      [_vShow, showTooltip.value]
    ])
  ], 34))
}
}

})